module.exports = __webpack_public_path__ + "img/bg_3.293081b5.png";